export const reportTheme = {
    token: {
      colorPrimary: 'var(--ant-primary-color)',
      colorLink: 'var(--ant-primary-color)',
      colorLinkHover: 'var(--ant-primary-color)',
      colorLinkActive: '#b35f25',
    },
    components: {
      Button: {
        colorPrimary: 'var(--ant-primary-color)',
        primaryShadow: 'none',
        defaultColor: 'var(--ant-primary-color)',
        defaultBorderColor: 'var(--ant-primary-color)',
        defaultHoverColor: 'var(--ant-primary-color)',
        defaultHoverBorderColor: 'var(--ant-primary-color)',
        primaryColor: '#fff',
      },
      Card: {
        colorBorderSecondary: '#f0f0f0',
      },
      Input: {
        hoverBorderColor: 'var(--ant-primary-color)',
        activeBorderColor: 'var(--ant-primary-color)',
        activeShadow: '0 0 0 2px rgba(222, 127, 57, 0.2)',
      },
      Select: {
        optionSelectedBg: '#88b99a',
        optionSelectedColor: '#262626',
        optionActiveBg: '#88b99a',
      },
      DatePicker: {
        hoverBorderColor: 'var(--ant-primary-color)',
        activeBorderColor: 'var(--ant-primary-color)',
      },
      Tabs: {
        itemActiveColor: 'var(--ant-primary-color)',
        itemHoverColor: 'var(--ant-primary-color)',
        inkBarColor: 'var(--ant-primary-color)',
      },
    },
  };